import React from 'react'
import ImportsPresenterCreated from './tabs/ImportsPresenterCreated'
import ImportsPresenterFailed from './tabs/ImportsPresenterFailed'

export default class ImportsPresenterTabContent extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="tab-content">
        <ImportsPresenterCreated {...this.props} />
        <ImportsPresenterFailed {...this.props}/>
      </div>
    );
  };
};
